import * as React from "react";
function SvgFacebook(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect fill="currentColor" height={32} rx={6} width={32} />
      <path
        d="M22.07 32V19.66h4.16l.62-4.81h-4.78v-3.07c0-1.39.39-2.34 2.39-2.34H27V5.13c-.44 0-2-.18-3.73-.18-3.68 0-6.2 2.24-6.2 6.35v3.55h-4.15v4.81h4.17V32z"
        fill="#fefefe"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgFacebook);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
